import cx from 'classnames'
import { FC } from 'react'

import '@/components/Layout/HeaderFooterCommon/Atoms/SlidingTextLink/ProductLinkItem.scss'
import ULink from '@/components/Link/ULink'

export type SlidingTextLinkProps = {
  href: string
  text: string
  className?: string
  nextLink?: boolean
}

const SlidingTextLink: FC<SlidingTextLinkProps> = ({ text, href, nextLink = true, className }) => {
  return (
    <li className={cx('c-slidingTextLink', { [className as string]: className })}>
      <ULink href={href} className="c-slidingTextLink__text u-mo-crop" nextLink={nextLink}>
        <span className="u-mo-crop__text u-mo-crop__text--inner">{text}</span>
        <span className="u-mo-crop__text u-mo-crop__text--outer">{text}</span>
      </ULink>
    </li>
  )
}

export default SlidingTextLink
